import { decrypt } from '../../utils/encrypt';

export const BLOG_API_BASE = 'https://chat-crm.lotusdew.in';

function parsePossiblyEncrypted(data) {
  if (data == null) {
    throw new Error('Empty response from blog API');
  }

  if (typeof data === 'object' && !Array.isArray(data)) {
    if (data.encryptedData) {
      return JSON.parse(decrypt(data.encryptedData));
    }
    if (data.Success !== undefined || data.Blogs !== undefined || data.content !== undefined) {
      return data;
    }
  }

  if (typeof data === 'string') {
    try {
      return JSON.parse(decrypt(data));
    } catch (e) {
      return JSON.parse(data);
    }
  }

  return data;
}

async function readJson(response) {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

export async function listBlogs(source) {
  const response = await fetch(`${BLOG_API_BASE}/blogs/list`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ source }),
  });
  const raw = await readJson(response);
  if (!response.ok) {
    const message =
      (raw && (raw.message || raw.error)) || `Failed to list blogs (${response.status})`;
    throw new Error(message);
  }
  const data = parsePossiblyEncrypted(raw);
  return Array.isArray(data.Blogs) ? data.Blogs : [];
}

export async function getBlogContent({ source, slug, title }) {
  const params = new URLSearchParams();
  params.set('source', source);
  if (slug) params.set('slug', slug);
  else if (title) params.set('title', title);

  const response = await fetch(
    `${BLOG_API_BASE}/blogs/blog/content?${params.toString()}`,
    { method: 'GET' }
  );
  const raw = await readJson(response);
  if (!response.ok) {
    const message =
      (raw && (raw.message || raw.error)) || `Failed to load blog (${response.status})`;
    throw new Error(message);
  }
  return parsePossiblyEncrypted(raw);
}

export async function updateBlog(payload) {
  const response = await fetch(`${BLOG_API_BASE}/blogs/blog/update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await readJson(response);
  if (!response.ok || data.Success === false) {
    throw new Error(
      (data && (data.message || data.error)) || `Failed to update blog (${response.status})`
    );
  }
  return data;
}

export async function insertBlog(payload) {
  const response = await fetch(`${BLOG_API_BASE}/blogs/blog/insert`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await readJson(response);
  if (!response.ok || data.Success === false) {
    throw new Error(
      (data && (data.message || data.error)) || `Failed to create blog (${response.status})`
    );
  }
  return data;
}

export function normalizeFaqsFromApi(faqs) {
  if (!faqs) return [];
  let list = faqs;
  if (typeof faqs === 'string') {
    try {
      list = JSON.parse(faqs);
    } catch (e) {
      return [];
    }
  }
  if (!Array.isArray(list)) return [];
  return list.map((item) => ({
    question: item.question || item.q || '',
    answer: item.answer || item.a || '',
  }));
}

export function faqsForApi(faqs) {
  return (faqs || [])
    .filter((item) => (item.question || '').trim() || (item.answer || '').trim())
    .map((item) => ({
      q: item.question,
      a: item.answer,
      question: item.question,
      answer: item.answer,
    }));
}
